<template>
    <div class="">
        <p>test</p>
    </div>
</template>
<script>
export default {
    name:"VerifyEmail"
}
</script>